import { createRouter, createWebHistory } from "vue-router";
import HomeOne from "../views/HomeOne.vue";
import About from "../views/About.vue";
import FAQ from "../views/FAQ.vue";
import ProjectsPage from "../views/ProjectsPage.vue";
import ProjectDetails from "../views/ProjectDetails.vue";
import Contact from "../views/Contact.vue";
import SensorData from "../views/SensorData.vue";
import SignIn from "../views/SignIn.vue";
import SignUp from "../views/SignUp.vue";
import UserInfo from "../views/UserInfo.vue";
import AuthView from "../views/AuthView.vue";
import AuthTest from "../views/AuthTest.vue";

const routes = [
  {
    path: "/",
    name: "HomeOne",
    component: HomeOne,
    meta: {
      title: "ASDL-IoT dashboard | Powered by EIDE",
    },
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/FAQ",
    name: "FAQ",
    component: FAQ,
  },
  {
    path: "/projects",
    name: "ProjectsPage",
    component: ProjectsPage,
  },
  {
    path: "/projects/:id",
    name: "ProjectDetails",
    component: ProjectDetails,
    props: true,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/sensor-data",
    name: "SensorData",
    meta: {
      title: "Sensor Data Page",
    },
    component: SensorData,
  },
  {
    path: "/sign-in",
    name: "SignIn",
    meta: {
      title: "Sign In Page",
    },
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "SignUp",
    meta: {
      title: "Sign Up Page",
    },
    component: SignUp,
  },
  {
    path: "/user-info",
    name: "UserInformation",
    meta: {
      title: "User Information Page",
    },
    component: UserInfo,
  },
  {
    path: "/auth/:pathMatch(.*)*",
    name: "auth",
    component: AuthView,
  },
  {
    path: "/auth/test",
    name: "AuthTest",
    component: AuthTest,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  console.log("Navigating to:", to.fullPath);
  next();
});

export default router;
